export const reportUnexpectedError = (context, error, metadata) => {
  if (metadata !== undefined) {
    console.error(`[${context}]`, error, metadata);
    return;
  }

  console.error(`[${context}]`, error);
};
